export const marketplaceMapTitle = {
  zoom: "Zoom统一身份认证案例_Zoom单点登录SSO集成案例-Authing身份云",
  google:
    "Google workspace统一身份认证案例_Google workspace单点登录集成案例-Authing身份云",
  github:
    "Github enterprise统一身份认证案例_Github enterprise单点登录集成案例-Authing身份云",
  jira: "Jira统一身份认证案例_Jira单点登录SSO案例-Authing身份云",
  confluence:
    "Confluence统一身份认证方案_单点登录集成案例_saas应用软件-Authing身份云",
  lark:
    "飞书统一身份认证案例_飞书单点登录SSO集成案例_saas市场应用-Authing身份云",
  gitlab:
    "GitLab统一身份认证案例_GitLab单点登录SSO集成案例_企业应用saas-Authing身份云",
  zabbix:
    "Zabbix统一身份认证案例_Zabbix单点登录SSO集成案例_saas云平台应用-Authing身份云",
  huaweicloud: "",
  "aliyun-user-sso":
    "阿里云统一身份认证案例_阿里云单点登录SSO集成案例_saas应用技术-Authing身份云",
  exmail:
    "腾讯企业邮箱统一身份认证案例_腾讯企业邮箱单点登录SSO集成案例-Authing身份云",
  "aws-china":
    "AWS统一身份认证案例_AWS单点登录SSO集成案例_saas云服务-Authing身份云",
  "service-desk-plus":
    "ServiceDesk plus统一身份认证案例_ServiceDesk plus单点登录SSO集成案例-Authing身份云",
  "tencent-cloud":
    "腾讯云统一身份认证案例_腾讯云单点登录SSO集成案例_Saas平台-Authing身份云",
  "service-desk-plus-cn":
    "国内ServiceDesk plus统一身份认证案例_国内ServiceDesk plus单点登录集成案例-Authing身份云",
  udesk: "Uedsk统一身份认证案例_Uedsk单点登录SSO集成案例-Authing身份云",
  hongyi: "鸿翼统一身份认证案例_鸿翼单点登录SSO集成案例-Authing身份云",
  gnway: "金万维统一身份认证案例_金万维单点登录SSO集成案例-Authing身份云",
  esign: "e签宝统一身份认证案例_e签宝单点登录SSO集成案例-Authing身份云",
  slack: "Slack统一身份认证案例_Slack单点登录SSO集成案例-Authing身份云",
  wordpress:
    "WordPress统一身份认证案例_WordPress单点登录SSO集成案例-Authing身份云",
  seafile: "Seafile统一身份认证案例_Seafile单点登录SSO集成案例-Authing身份云",
  kibana: "Kibana统一身份认证案例_Kibana单点登录SSO集成案例-Authing身份云",
  jenkins: "Jenkins统一身份认证案例_Jenkins单点登录SSO集成案例-Authing身份云",
  teambition:
    "Teambition统一身份认证案例_Teambition单点登录SSO集成案例-Authing身份云",
  salesforce:
    "Salesforce统一身份认证案例_Salesforce单点登录SSO集成案例-Authing身份云",
  jfrog: "JFrog统一身份认证案例_JFrog单点登录SSO集成案例-Authing身份云",
  zendesk: "ZenDesk统一身份认证案例_ZenDesk单点登录SSO集成案例-Authing身份云",
  fxiaoke: "纷享销客对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  adobe: "adobe对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  expensify: "expensify对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  qingflow: "轻流对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  strapi: "strapi对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  "aliyun-intel-user-sso":
    "阿里云国际区对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  aws: "aws国际区对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  maycur: "每刻报销对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  discourse: "discourse对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  bitbucket: "bitbucket对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  sonarqube: "sonarqube对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  sentry: "sentry对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  jamf: "jamf pro对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  beisen: "北森对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  xiaoshouyi: "销售易对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  metabase: "metabase对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  grafana: "grafana对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  "baidu-role-sso":
    "百度智能云对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  "baidu-user-sso":
    "百度智能云对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  jiandaoyun: "简道云对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  atlassian:
    "atlassian cloud对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  mokahr: "moka对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  vecorplink: "飞连对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  eolinker: "eolinker对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  consoleMe: "consoleme对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  rollbar: "rollbar对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  perforce: "perforce对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  sapbtp: "SAP对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  polyv: "保利威对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  mulesoft: "muleSoft对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  ksyun: "金山云对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  "tencent-cloud-user":
    "腾讯云用户SSO对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  jumpserver: "jumpServer对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  dropbox: "dropbox对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
  splunk: "splunk对接 - 单点登录配置 - 应用身份服务 - Authing 身份云",
};
export const marketplaceMapDescription = {
  zoom:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Zoom统一身份认证案例,Zoom单点登录SSO集成案例,企业应用saas,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  google:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Google workspace统一身份认证案例,Google workspace单点登录集成案例,企业应用saas,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  github:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供；Github enterprise统一身份认证案例_Github enterprise单点登录集成案例,企业应用saas,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  jira:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Jira统一身份认证案例,Jira单点登录SSO案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  confluence:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供各种Confluence统一身份认证方案,单点登录集成案例,saas应用软件,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  lark:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供飞书统一身份认证案例,飞书单点登录集成案例,saas市场应用,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  gitlab:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供GitLab统一身份认证案例,GitLab单点登录SSO集成案例,企业应用saas,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  zabbix:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Zabbix统一身份认证案例,Zabbix单点登录SSO集成案例,saas云平台应用,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  huaweicloud: "",
  "aliyun-user-sso":
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供阿里云统一身份认证案例,阿里云单点登录SSO集成案例,saas应用技术,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  exmail:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供腾讯企业邮箱统一身份认证案例,腾讯企业邮箱单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  "aws-china":
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供AWS统一身份认证案例,AWS单点登录SSO集成案例,saas云服务,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  "service-desk-plus":
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供ServiceDesk plus统一身份认证案例,ServiceDesk plus单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  "tencent-cloud":
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供腾讯云统一身份认证案例,腾讯云单点登录SSO集成案例,Saas平台,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  "service-desk-plus-cn":
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供国内ServiceDesk plus统一身份认证案例,国内ServiceDesk plus单点登录集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  udesk:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Uedsk统一身份认证案例,Uedsk单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  hongyi:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供鸿翼统一身份认证案例,鸿翼单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  gnway:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供金万维统一身份认证案例，金万维单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  esign:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供e签宝统一身份认证案例,e签宝单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  slack:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Slack统一身份认证案例,Slack单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  wordpress:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供WordPress统一身份认证案例,WordPress单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  seafile:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Seafile统一身份认证案例,Seafile单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  kibana:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Kibana统一身份认证案例,Kibana单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  jenkins:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Jenkins统一身份认证案例,Jenkins单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  teambition:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Teambition统一身份认证案例,Teambition单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  salesforce:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供Salesforce统一身份认证案例,Salesforce单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  jfrog:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供JFrog统一身份认证案例,JFrog单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  zendesk:
    "Authing 身份云是国内首款以开发者为中心的全场景身份云产品，为企业提供单点登录 SSO ，统一身份认证平台 ，Authing 在应用市场中提供了多种安全有效的授权方式，提供ZenDesk统一身份认证案例,ZenDesk单点登录SSO集成案例,Authing应用市场所有上架的应用都是经过 Authing 严格的安全认证。",
  fxiaoke:
    "纷享销客-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 纷享销客对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  adobe:
    "adobe-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 adobe对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  expensify:
    "expensify-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 expensify对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  qingflow:
    "轻流-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 轻流对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  strapi:
    "strapi-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 strapi对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  "aliyun-intel-user-sso":
    "阿里云国际区-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 阿里云国际区对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  aws:
    "aws国际区-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 aws国际区对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  maycur:
    "每刻报销-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 每刻报销对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  discourse:
    "discourse-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 discourse对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  bitbucket:
    "bitbucket-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 bitbucket对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  sonarqube:
    "sonarqube-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 sonarqube对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  sentry:
    "sentry-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 sentry对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  jamf:
    "jamf pro-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 jamf pro对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  beisen:
    "北森-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 北森对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  xiaoshouyi:
    "销售易-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 销售易对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  metabase:
    "metabase-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 metabase对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  grafana:
    "grafana-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 grafana对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  "baidu-role-sso":
    "百度智能云-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 百度智能云对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  "baidu-user-sso":
    "百度智能云-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 百度智能云对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  jiandaoyun:
    "简道云-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 简道云对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  atlassian:
    "atlassian cloud-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 atlassian cloud对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  mokahr:
    "moka-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 moka对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  vecorplink:
    "飞连-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 飞连对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  eolinker:
    "eolinker-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 eolinker对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  consoleMe:
    "consoleme-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 consoleme对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  rollbar:
    "rollbar-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 rollbar对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  perforce:
    "perforce-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 perforce对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  sapbtp:
    "SAP-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 SAP对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  polyv:
    "保利威-oidc应用主要实现支撑单点登录流程的功能。Authing合作网络提供 保利威对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  mulesoft:
    "muleSoft-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 muleSoft对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  ksyun:
    "金山云-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 金山云对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  "tencent-cloud-user":
    "腾讯云用户SSO-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 腾讯云用户SSO对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  jumpserver:
    "jumpserver-cas应用主要实现支撑单点登录流程的功能。Authing合作网络提供 jumpserver对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  dropbox:
    "dropbox-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 dropbox对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
  splunk:
    "splunk-saml应用主要实现支撑单点登录流程的功能。Authing合作网络提供 splunk对接，单点登录，SSO，实现应用的快捷登录、免密登录，提升员工办公体验、增强用户体验，增强企业数字化服务水平。",
};
export const marketplaceMapKeywords = {
  zoom: "Zoom统一身份认证案例,Zoom单点登录SSO集成案例",
  google: "Google workspace统一身份认证案例,Google workspace单点登录集成案例",
  github: "Github enterprise统一身份认证案例_Github enterprise单点登录集成案例",
  jira: "Jira统一身份认证案例,Jira单点登录SSO案例,Authing应用市场",
  confluence: "Confluence统一身份认证方案,单点登录集成案例,saas应用软件",
  lark: "飞书统一身份认证案例,飞书单点登录集成案例,saas市场应用",
  gitlab: "GitLab统一身份认证案例,GitLab单点登录SSO集成案例,企业应用saas",
  zabbix: "Zabbix统一身份认证案例,Zabbix单点登录SSO集成案例,saas云平台应用",
  huaweicloud: "",
  "aliyun-user-sso":
    "阿里云统一身份认证案例,阿里云单点登录SSO集成案例,saas应用技术",
  exmail: "腾讯企业邮箱统一身份认证案例,腾讯企业邮箱单点登录SSO集成案例",
  "aws-china": "AWS统一身份认证案例,AWS单点登录SSO集成案例,saas云服务",
  "service-desk-plus":
    "ServiceDesk plus统一身份认证案例,ServiceDesk plus单点登录SSO集成案例",
  "tencent-cloud": "腾讯云统一身份认证案例,腾讯云单点登录SSO集成案例,Saas平台",
  "service-desk-plus-cn":
    "国内ServiceDesk plus统一身份认证案例,国内ServiceDesk plus单点登录集成案例",
  udesk: "Uedsk统一身份认证案例,Uedsk单点登录SSO集成案例",
  hongyi: "鸿翼统一身份认证案例,鸿翼单点登录SSO集成案例",
  gnway: "金万维统一身份认证案例,金万维单点登录SSO集成案例",
  esign: "e签宝统一身份认证案例,e签宝单点登录SSO集成案例",
  slack: "Slack统一身份认证案例,Slack单点登录SSO集成案例",
  wordpress: "WordPress统一身份认证案例,WordPress单点登录SSO集成案例",
  seafile: "Seafile统一身份认证案例,Seafile单点登录SSO集成案例",
  kibana: "Kibana统一身份认证案例,Kibana单点登录SSO集成案例",
  jenkins: "Jenkins统一身份认证案例,Jenkins单点登录SSO集成案例",
  teambition: "Teambition统一身份认证案例,Teambition单点登录SSO集成案例",
  salesforce: "Salesforce统一身份认证案例,Salesforce单点登录SSO集成案例",
  jfrog: "JFrog统一身份认证案例,JFrog单点登录SSO集成案例",
  zendesk: "ZenDesk统一身份认证案例,ZenDesk单点登录SSO集成案例",
  fxiaoke:
    "纷享销客,纷享销客软件,纷享销客SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  adobe:
    "adobe,adobe软件, adobeSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  expensify:
    "expensify, expensify软件, expensifySaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  qingflow:
    "轻流,轻流软件, 轻流SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  strapi:
    "strapi, strapi软件, strapiSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  "aliyun-intel-user-sso":
    "阿里云国际区,阿里云国际区软件, 阿里云国际区SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  aws:
    "aws国际区,aws国际区软件, aws国际区SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  maycur:
    "每刻报销,每刻报销软件, 每刻报销SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  discourse:
    "discourse,discourse软件, discourseSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  bitbucket:
    "bitbucket,bitbucket软件, bitbucketSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  sonarqube:
    "sonarqube,sonarqube软件, sonarqubeSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  sentry:
    "sentry,sentry软件, sentrySaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  jamf:
    "jamf pro,jamf pro软件, jamf proSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  beisen:
    "北森,北森软件, 北森SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  xiaoshouyi:
    "销售易,销售易软件, 销售易SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  metabase:
    "metabase,metabase软件, metabaseSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  grafana:
    "grafana, grafana软件, grafanaSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  "baidu-role-sso":
    "百度智能云,百度智能云软件, 百度智能云SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  "baidu-user-sso":
    "百度智能云,百度智能云软件, 百度智能云SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  jiandaoyun:
    "简道云,简道云软件, 简道云SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  atlassian:
    "atlassian cloud,atlassian cloud软件, atlassian cloudSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  mokahr:
    "moka, moka软件, mokaSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  vecorplink:
    "飞连, 飞连软件, 飞连SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  eolinker:
    "eolinker, eolinker软件, eolinkerSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  consoleMe:
    "consoleme, consoleme软件, consolemeSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  rollbar:
    "rollbar, rollbar软件, rollbarSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  perforce:
    "perforce, perforce软件, perforceSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  sapbtp: "SAP, SAP软件, SAPSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  polyv:
    "保利威, 保利威软件, 保利威SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  mulesoft:
    "muleSoft, muleSoft软件, muleSoftSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  ksyun:
    "金山云, 金山云软件, 金山云SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  "tencent-cloud-user":
    "腾讯云, 腾讯云软件, 腾讯云SaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  jumpserver:
    "jumpserver, jumpserver软件, jumpserverSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  dropbox:
    "dropbox, dropbox软件, dropboxSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
  splunk:
    "splunk, splunk软件, splunkSaaS, SSO,应用身份服务,单点登录配置,Authing身份云",
};
